"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteClinicAvailabilityData = exports.postClinicAvailabilityData = exports.putClinicAvailabilityData = exports.getClinicDetail = exports.getAgendaOverview = exports.deleteUnavailabilityData = exports.putUnavailabilityData = exports.postUnavailabilityData = exports.getAvailabilityData = void 0;
var transformUnavailableRange_1 = __importDefault(require("./transformUnavailableRange"));
var axios_1 = __importDefault(require("axios"));
exports.getAvailabilityData = function () { return __awaiter(void 0, void 0, void 0, function () {
    var result, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/api/availability")];
            case 1:
                result = _a.sent();
                if (result.status === 401)
                    return [2 /*return*/, Error('Access forbidden: is your IP allowed on the server?')];
                if (result.status > 300)
                    return [2 /*return*/, Error('Failed to retrieve availability')];
                return [4 /*yield*/, result.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
exports.postUnavailabilityData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    method: 'post',
                    url: '/api/availability/supplierDateUnavailability',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data,
                })
                    .then(function (res) {
                    console.log('res', res);
                    // window.location.href = '/confirmed';
                })
                    .catch(function (err) {
                    console.log(err);
                    return Error(err);
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.putUnavailabilityData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var dataToUpdate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dataToUpdate = __assign({ id: data.id }, transformUnavailableRange_1.default(data));
                return [4 /*yield*/, axios_1.default({
                        method: 'put',
                        url: '/api/availability/supplierDateUnavailability',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: dataToUpdate,
                    })
                        .then(function (res) {
                        // console.log(res);
                        // window.location.href = '/confirmed';
                    })
                        .catch(function (err) {
                        console.log(err);
                        return Error(err);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.deleteUnavailabilityData = function (id) {
    axios_1.default.delete("/api/availability/supplierDateUnavailability/" + id, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
exports.getAgendaOverview = function () { return __awaiter(void 0, void 0, void 0, function () {
    var result, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/api/schedules")];
            case 1:
                result = _a.sent();
                if (result.status === 401)
                    return [2 /*return*/, Error('Access forbidden: is your IP allowed on the server?')];
                if (result.status > 300)
                    return [2 /*return*/, Error('Failed to retrieve agenda overview')];
                return [4 /*yield*/, result.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
exports.getClinicDetail = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var result, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("/api/schedule/" + id)];
            case 1:
                result = _a.sent();
                if (result.status === 401)
                    return [2 /*return*/, Error('Access forbidden: is your IP allowed on the server?')];
                if (result.status > 300)
                    return [2 /*return*/, Error('Failed to retrieve clinic detail')];
                return [4 /*yield*/, result.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
exports.putClinicAvailabilityData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    method: 'put',
                    url: '/api/availability/supplierClinicAvailability',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data,
                })
                    .then(function (res) {
                    return res;
                })
                    .catch(function (err) {
                    console.log(err);
                    return Error(err);
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.postClinicAvailabilityData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    method: 'post',
                    url: '/api/availability/supplierClinicAvailability',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data,
                })
                    .then(function (res) {
                    return res;
                })
                    .catch(function (err) {
                    console.log(err);
                    return Error(err);
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.deleteClinicAvailabilityData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    method: 'delete',
                    url: "/api/availability/supplierClinicAvailability/" + data.id + "}",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: data,
                })
                    .then(function (res) {
                    console.log(res);
                    return res;
                })
                    .catch(function (err) {
                    console.log(err);
                    return Error(err);
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
